"use client";

import Link from "next/link";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const BannerSlides = [
  {
    title: "Hunt Commissions Like a Tiger – Join The Dalal Affiliates Pride!",
    subtitle: "⚡ Effortless Start. Endless Income.",
  },
  {
    title: "Highest Benefits x 50% Commission",
    subtitle: "⚡ Only 300 Turnover for Active Players, Zero Payment Fees!",
  },
  {
    title: "Multi-Platform Support",
    subtitle: "⚡ Seamless on Mobile & Desktop, Wider Reach, More Conversions.",
  },
];

const BannerContentSlider = () => {
  return (
    <div className="absolute inset-0 z-40 w-full h-full">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation={{
          nextEl: "#banner-next",
          prevEl: "#banner-prev",
        }}
        pagination={{ clickable: true }}
        autoplay={{ delay: 3500 }}
        loop
        className="w-full h-full"
      >
        {BannerSlides.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="h-full flex flex-col justify-end pb-24 lg:pb-0 lg:justify-center container mx-auto items-start text-left max-lg:px-0!">
              <h1 
                className={`font-semibold font-sans tracking-[-0.58px] text-[30px] max-lg:leading-[48px] leading-[1.2] lg:text-[56px]/[64px] text-text1 max-w-[720px] max-lg:max-w-[374px] ${
                  item.title === "Highest Benefits x 50% Commission" ? "max-lg:text-[32px] max-lg:w-[374px] max-lg:h-[144px] max-lg:flex max-lg:flex-col max-lg:justify-between max-lg:py-0" : ""
                }`}
              >
                {item.title === "Highest Benefits x 50% Commission" ? (
                  <>
                    Highest Benefits x 50% <br /> Commission
                  </>
                ) : (
                  item.title
                )}
              </h1>

              <p className="mt-8 lg:mt-6 font-sans lg:text-[20px] text-[12px] text-text1">
                {item.subtitle}
              </p>

              <div className="mt-[54px] lg:mt-12 flex lg:flex-row flex-col items-center lg:items-start gap-4 lg:gap-5 w-full max-lg:px-0">
                <Link
                  className="btn font-bold text-black bg-white hover:bg-text5 hover:text-white transition-all duration-300 ease-in-out lg:w-fit w-full text-[16px] h-[60px] rounded-full flex items-center justify-center shadow-sm relative overflow-hidden"
                  href="#about"
                >
                  Get Started
                  <span className="shine-effect" aria-hidden="true"></span>
                </Link>

                <Link
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="btn font-bold text-white bg-transparent border-2 border-white hover:bg-text5 hover:border-text5 hover:text-white transition-all duration-300 ease-in-out lg:w-fit w-full text-[16px] h-[60px] rounded-full flex items-center justify-center relative overflow-hidden"
                  href="https://baghpartners.com/page/affiliate/login.jsp"
                >
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 512 512"
                    height="1em"
                    width="1em"
                    className="mr-2"
                  >
                    <path d="M133 440a35.37 35.37 0 0 1-17.5-4.67c-12-6.8-19.46-20-19.46-34.33V111c0-14.37 7.46-27.53 19.46-34.33a35.13 35.13 0 0 1 35.77.45l247.85 148.36a36 36 0 0 1 0 61l-247.89 148.4A35.5 35.5 0 0 1 133 440z"></path>
                  </svg>
                  Register Now
                  <span className="shine-effect shine-orange" aria-hidden="true"></span>
                </Link>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Navigation */}
      <div className="absolute inset-0 z-50 pointer-events-none">
        <div className="container mx-auto h-full relative">
          <button
            id="banner-prev"
            className="absolute -left-2 lg:-left-20 top-[73%] lg:top-1/2 -translate-y-1/2 w-[calc(var(--spacing)*11)] h-[calc(var(--spacing)*11)] lg:w-11 lg:h-11 rounded-full grid place-items-center opacity-40 hover:opacity-100 transition-opacity pointer-events-auto"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="text-white size-[36px] lg:size-6 lg:stroke-[2]"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17.25 21.75L6.75 12l10.5-9.75"
              />
            </svg>
          </button>

          <button
            id="banner-next"
            className="absolute -right-2 lg:-right-20 top-[73%] lg:top-1/2 -translate-y-1/2 w-[calc(var(--spacing)*11)] h-[calc(var(--spacing)*11)] lg:w-11 lg:h-11 rounded-full grid place-items-center opacity-40 hover:opacity-100 transition-opacity pointer-events-auto"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="text-white size-[36px] lg:size-6 lg:stroke-[2]"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.75 2.25l10.5 9.75-10.5 9.75"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BannerContentSlider;
